var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'guideline-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      guideline_content: '',
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    guidelines () {
      return this.$store.getters.guidelineList
    },
    nextPage () {
      return this.$store.getters.guidelineListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.guidelineListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {'guideline_content': this.guideline_content}
      this.$store.dispatch('GUIDELINE_LIST_SEARCH', {url: url, data:data, callback: callback})
    },
    goGuidelineNew: function () {
      this.$router.push({ path: '/guidelines/new', query: { type: this.$router.currentRoute.query.type}})
    },
    goGuidelineEdit: function(guidelineId) {
      this.$router.push({ path: '/guidelines/' + guidelineId + '/edit'})
    },
    guidelineDelete: function(guidelineId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('GUIDELINE_DELETE',  {id: guidelineId, callback: this.onSaved})
      }
    },
    half: function () {
      this.guideline_content = utils.emHalf(this.guideline_content)
    },
    onSaved: function (result) {
      this.$router.push('/guidelines')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/guideline-list.js